import React from "react";
import { Text } from "@mantine/core";

export function DashTable() {
  return (
    <Text ff="Inter" fz={14} c={"#737373"} fw={400} align="center" py={20}>
      No records available.
    </Text>
  );
}
